import { IconName } from '@bytel/trilogy-react';

import { PalpatineDetailedPlanType } from '@app-types/api/palpatine';
import { MobilePlanType } from '@app-types/plan';

export class SapiMapper {
    static mapCmsPlan(planCms?: PalpatineDetailedPlanType | undefined): MobilePlanType['cmsContent'] {
        if (!planCms) {
            return {};
        }
        return {
            addedPepites: planCms.add_pepites?.map((p) => ({
                pepite: p.pepite ?? '',
                icon: (p.icon_trilogy as IconName) ?? '',
            })),
            bigBenefit: planCms.big_benefit_text ?? '',
            modalCustomDestinationPartial: planCms.modal_destination_custom_partial ?? '',
        };
    }
}
